var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAndChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.162,
    height: 146.219,
    viewBox: "0 0 153.162 146.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-81.84 -102.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(81.84 102.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M321.183,174.242h-.8V152.236A12.736,12.736,0,0,0,307.643,139.5H261.021a12.736,12.736,0,0,0-12.736,12.736V272.962A12.736,12.736,0,0,0,261.021,285.7h46.622a12.736,12.736,0,0,0,12.736-12.736V189.906h.8Z",
    transform: "translate(-233.071 -139.5)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M317.669,151.783h-6.086a4.519,4.519,0,0,1-4.184,6.225H280.69a4.519,4.519,0,0,1-4.184-6.225h-5.684a9.511,9.511,0,0,0-9.511,9.511V281.843a9.511,9.511,0,0,0,9.511,9.511h46.847a9.511,9.511,0,0,0,9.511-9.511h0V161.294a9.511,9.511,0,0,0-9.511-9.511Z",
    transform: "translate(-242.583 -148.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M294.947,680.04H192.162a.27.27,0,1,1,0-.54H294.947a.27.27,0,1,1,0,.54Z",
    transform: "translate(-191.892 -533.82)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 22.782,
    cy: 22.782,
    r: 22.782,
    transform: "translate(28.881 47.693)",
    fill: "#3a7735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M354.093,386.048a2.363,2.363,0,0,1-1.421-.472l-.025-.019-5.354-4.1a2.379,2.379,0,1,1,2.9-3.776l3.468,2.659,8.195-10.691a2.378,2.378,0,0,1,3.334-.44h0l-.051.071.052-.071a2.381,2.381,0,0,1,.44,3.335l-9.639,12.569a2.38,2.38,0,0,1-1.892.928Z",
    transform: "translate(-304.689 -306.883)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(186.392 173.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M882.339,597.636a3.2,3.2,0,0,1,.439-.56c.069-.071.141-.139.216-.2a3.428,3.428,0,0,1,5.652,1.95c.5-1.858-.805-3.687-2.12-5.093s-2.819-2.946-2.811-4.872a3.709,3.709,0,0,1,1.319-2.736l.074-.064a5,5,0,0,1,3.445-1.2,8.227,8.227,0,0,1,5.8,3.561c2.282,3,3.282,7.21,1.685,10.625-1.406,3-4.4,4.786-7.462,6.22q-.641.3-1.279.583l-.009,0-.06.027-.263.116.04.026.126.081-.13-.078-.04-.024a13.338,13.338,0,0,1-4.064-3.263A4.706,4.706,0,0,1,882.339,597.636Z",
    transform: "translate(-848.584 -531.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M899.328,602.9a8.506,8.506,0,0,1,.655,2.379,7.385,7.385,0,0,1-.089,2.194,9.46,9.46,0,0,1-1.9,4.059,13.617,13.617,0,0,1-2.458,2.39q-.641.3-1.279.583l-.009,0-.06.027-.263.116.04.026.126.081-.13-.078-.04-.024a7.46,7.46,0,0,0-4.181-8.922c.069-.071.141-.139.216-.2a7.867,7.867,0,0,1,1.206.689,7.711,7.711,0,0,1,2.918,3.866,7.883,7.883,0,0,1,.171,4.408c.075-.049.151-.1.225-.15a13.823,13.823,0,0,0,3.661-3.468,8.8,8.8,0,0,0,1.562-3.969,7.954,7.954,0,0,0-.9-4.495,18.427,18.427,0,0,0-2.886-4.1,20.935,20.935,0,0,0-3.87-3.328.151.151,0,0,1-.045-.2.128.128,0,0,1,.074-.064.112.112,0,0,1,.095.019c.175.117.349.235.521.357a21.174,21.174,0,0,1,3.869,3.534A17.042,17.042,0,0,1,899.328,602.9Z",
    transform: "translate(-855.549 -539.677)",
    fill: "#3a7735"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-2",
    "data-name": "Ellipse 44",
    cx: 2.184,
    cy: 2.184,
    r: 2.184,
    transform: "translate(10.962 0)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-3",
    "data-name": "Ellipse 44",
    cx: 1.332,
    cy: 1.332,
    r: 1.332,
    transform: "translate(38.975 30.936)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-4",
    "data-name": "Ellipse 44",
    cx: 1.332,
    cy: 1.332,
    r: 1.332,
    transform: "translate(0 34.59)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M625.23,758.744h46.4a.122.122,0,1,0,0-.244h-46.4a.122.122,0,1,0,0,.244Z",
    transform: "translate(-623.146 -683.515)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M913.2,221.471a1.785,1.785,0,0,0-3.427-.9l-3.766,4.317,1.1,3.086,3.787-5.044a1.775,1.775,0,0,0,2.3-1.454Z",
    transform: "translate(-869.834 -210.108)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M609.94,119.033l12.5-13.34-1.686-2.681-15.678,13.259Z",
    transform: "translate(-582.182 -90.873)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 4.385,
    cy: 4.385,
    r: 4.385,
    transform: "translate(20.584 11.285)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M816.894,232.831a9.194,9.194,0,0,1,3.345-2.163,4.706,4.706,0,0,1,2.534-.315,2.415,2.415,0,0,1,1.881,1.584,2.99,2.99,0,0,1-.306,2.047c-.3.638-.7,1.23-.941,1.893a4.32,4.32,0,0,0,4.347,5.793,21.5,21.5,0,0,0-2.408.709,2.523,2.523,0,0,1-2.373-.388,3.23,3.23,0,0,1-.62-2.5q.069-1.976.138-3.952a5.018,5.018,0,0,0-.2-1.992,1.711,1.711,0,0,0-1.49-1.17,2.445,2.445,0,0,0-1.369.617,2.8,2.8,0,0,1-1.348.674c-.507.045-1.087-.33-1.049-.838Z",
    transform: "translate(-791.573 -219.638)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M660.955,458.591a1.785,1.785,0,0,1-1.345-3.279l3.788-4.3,3.2.692L662.1,456.12a1.775,1.775,0,0,1-1.141,2.471Z",
    transform: "translate(-652.64 -413.48)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M498.874,198.759l-9.441,11.851-2.878-1.321,11.1-17.276Z",
    transform: "translate(-478.097 -169.033)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M509.624,540.956l-2.25-.035.271,7.669h1.979Z",
    transform: "translate(-496.38 -475.446)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M675.868,738.081h-3.9a2.484,2.484,0,0,0-2.484,2.484v.081h6.382Z",
    transform: "translate(-662.119 -665.583)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M630.442,524.511l-2.458,1.578L632.9,532l1.665-1.069Z",
    transform: "translate(-602.3 -461.034)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M842.655,710.049l-3.28,2.106h0a2.484,2.484,0,0,0-.748,3.432l.044.068,5.37-3.448Z",
    transform: "translate(-810.313 -640.965)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M708.472,339.12s-5.461-18.139-7.216-18.384-4.583,4.654-4.583,4.654c-3.667,4.678-7.447,19.831-7.447,19.831s6.3.394,10.91,2.846,10.044-.124,10.044-.124Z",
    transform: "translate(-679.454 -299.061)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M708.472,339.12s-5.461-18.139-7.216-18.384-3.865,4.7-3.865,4.7c-1.827,7.551-8.165,19.781-8.165,19.781s6.3.394,10.91,2.846,10.044-.124,10.044-.124Z",
    transform: "translate(-679.454 -299.062)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M515.648,278.564v9.115l1.073,13.2,5.359,9.987-2.558,1.827-7.308-9.5-2.89-9.433-4.539,20.882-3.41-.244,2.368-28.952,4.494-8.149Z",
    transform: "translate(-491.111 -243.933)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M750.321,324.941a2.571,2.571,0,0,0-.122,3.532l-1.949,4.385,7.673,2.071,2.682-11.982L756.778,321a26.05,26.05,0,0,1-3.656-.2A45.736,45.736,0,0,0,750.321,324.941Z",
    transform: "translate(-731.29 -299.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M784.943,323.615a3.274,3.274,0,0,0-4.6.72,11.913,11.913,0,0,0-1.255,12.432c3.946,8.685,7.38,13.131,8.776,13.131a.555.555,0,0,0,.18-.028,4.575,4.575,0,0,0,2.327-3.027,1.535,1.535,0,0,0-.487-1.536c-1.576-1.26-4.4-5.184-5.286-10.348a11.448,11.448,0,0,1,1.337-7.131,3.274,3.274,0,0,0-.947-4.181h0Z",
    transform: "translate(-757.319 -301.036)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 3.228,
    cy: 3.228,
    r: 3.228,
    transform: "translate(19.265 15.508) rotate(-28.663)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M765.872,253.124h4.661l.048-.669.239.669h.718l.095-1.326.474,1.326h1.389v-.066a3.486,3.486,0,0,0-3.482-3.482h-.657a3.486,3.486,0,0,0-3.482,3.482Z",
    transform: "translate(-746.766 -236.576)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M809.924,258.975l1.989-.645V253.5h-3.757l.093.093C809.543,254.885,810.982,259.47,809.924,258.975Z",
    transform: "translate(-783.899 -240.022)",
    fill: "#2f2e41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAndChild);
export default __webpack_public_path__ + "static/media/mobileAndChild.2bb1053b2bd58db9c114de0ce560f8a8.svg";
export { ForwardRef as ReactComponent };